import { Button, ButtonColorVariant, ButtonVariant } from "@/components/ui/button";
import { useTranslation } from "react-i18next";

interface AppRoleGroupTableFooterProps {
  totalSelectedCount: number;
  onClearSelection: () => void;
}

export function AppRoleGroupTableFooter({ totalSelectedCount, onClearSelection }: AppRoleGroupTableFooterProps) {
  const { t } = useTranslation();

  return (
    <div className="flex flex-row items-center justify-between gap-4">
      <div className="flex flex-row items-center gap-4">
        <span className="text-center text-sm font-medium sm:text-left">
          {t("ram:SelectedGroupsCount", { count: totalSelectedCount })}
        </span>
        <Button
          type="button"
          variant={ButtonVariant.Outlined}
          colorVariant={ButtonColorVariant.Secondary}
          onClick={onClearSelection}
        >
          {t("common:ClearSelection")}
        </Button>
      </div>
    </div>
  );
}
